import { TransactionsDateFilterState } from './TransactionsDateFilterState';

export function isTransactionsDateFilterChanged(state: TransactionsDateFilterState): boolean {
  return (
    state.started !== null ||
    state.startedDateRange !== null ||
    state.approved !== null ||
    state.approvedBy !== null ||
    state.approvedDateRange !== null
  );
}
